import { render, staticRenderFns } from "./DialogNotice.vue?vue&type=template&id=4279cd6e&scoped=true&"
import script from "./DialogNotice.vue?vue&type=script&lang=js&"
export * from "./DialogNotice.vue?vue&type=script&lang=js&"
import style0 from "./DialogNotice.vue?vue&type=style&index=0&id=4279cd6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4279cd6e",
  null
  
)

export default component.exports